import React from 'react';
import '../Stylesheets/index.css';
import Header from './Header';
import Body from './Body';
import Bottom from './Bottom';

function DocumentStructure() {
    return (
        <div id="ApplicationStructure">
            <Header />
            <Body />
            <Bottom />
        </div>
    );
}

export default DocumentStructure;
